import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Dispatch, ORVRoute } from 'orv-ui-base-lib';

@Component({
	selector: 'app-kpitable',
	templateUrl: './kpitable.component.html',
	styleUrls: ['./kpitable.component.scss']
})
export class KpitableComponent implements OnInit {


	costs = [{ label: 'Maintenance', field: 'maintcost' },
	{ label: 'Infrastructure', field: 'cpicost' },
	{ label: 'Fuel', field: 'fuelcost' },
	{ label: 'Insurance', field: 'inscost' },
	{ label: 'Labour', field: 'labourcost' },
	{ label: 'Toll', field: 'tollcost' },
	];


	@Input() notoptimized: ORVRoute;
	@Input() optimized: ORVRoute;
	@Input() travelled: Dispatch;
	@Input() responsive: boolean;

	showCloseButton: boolean = false;

	constructor(private activeModal: NgbActiveModal) {}

	close() {
		this.activeModal.close();
	}

	ngOnInit() {
	}

}
